import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=bd4c64b2&scoped=true"
import script from "./Modify.vue?vue&type=script&lang=js"
export * from "./Modify.vue?vue&type=script&lang=js"
import style0 from "./Modify.vue?vue&type=style&index=0&id=bd4c64b2&prod&lang=stylus"
import style1 from "./Modify.vue?vue&type=style&index=1&id=bd4c64b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4c64b2",
  null
  
)

export default component.exports